import { Navigate, useLocation } from 'react-router-dom';

import { UserFlow } from '@/types';

/**
 * Logto exposes both `/reset-password` (firstScreen) and `/forgot-password`.
 * ClinicOS uses a single recovery URL: `/forgot-password`.
 */
const ResetPasswordLanding = () => {
  const { search } = useLocation();

  return <Navigate replace to={`/${UserFlow.ForgotPassword}${search}`} />;
};

export default ResetPasswordLanding;
